import { useConnection } from '@/features/connection/ConnectionContext'
import { Button } from '@/components/ui/Button'
import { Calendar } from 'lucide-react'

export function SplashScreen() {
  const { connect, status } = useConnection()

  const isConnecting = status === 'connecting'

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-zinc-950 px-4">
      <div className="flex flex-col items-center gap-8 max-w-md text-center">
        {/* Logo */}
        <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-zinc-800 to-zinc-900 flex items-center justify-center shadow-lg">
          <Calendar className="w-12 h-12 text-white" />
        </div>

        {/* Title */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-white">E-Ink Photo Calendar</h1>
          <p className="text-zinc-400">Display your memories, daily.</p>
        </div>

        {/* Connect Button */}
        <Button
          onClick={connect}
          disabled={isConnecting}
          size="lg"
          className="min-w-[200px]"
        >
          {isConnecting ? (
            <>
              <span className="animate-spin mr-2">⏳</span>
              Connecting...
            </>
          ) : (
            'Connect to Device'
          )}
        </Button>

        {/* Info text */}
        <p className="text-xs text-zinc-600">
          Make sure your device is connected via USB and powered on.
        </p>
      </div>
    </div>
  )
}
